import { render, staticRenderFns } from "./adoutXq.vue?vue&type=template&id=8caf6890&scoped=true"
import script from "./adoutXq.vue?vue&type=script&lang=js"
export * from "./adoutXq.vue?vue&type=script&lang=js"
import style0 from "./adoutXq.vue?vue&type=style&index=0&id=8caf6890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8caf6890",
  null
  
)

export default component.exports